const getErrorsFromResponse = async (response): Promise<string[]> => {
  if (!response) return [];
  if (!response.json && response.statusText) return Promise.resolve([response.statusText]);
  if (!response.json) return Promise.resolve([]);

  const parsedResponse = await response.json();

  if (parsedResponse && parsedResponse.errors) {
    return parsedResponse.errors.map((error) => error.msg);
  }

  if (parsedResponse && parsedResponse.message) {
    return [parsedResponse.message];
  }

  return [`Something went wrong (${response.statusText})`];
};

export default getErrorsFromResponse;
